<template>
    <div class="row mb-3">
        <div :class="{'col-12': searchType !== 'Smart', 'col order-1': searchType === 'Smart'}">
            <div :class="{'full-row': showCriteria && ($route.params.search_id && $store.state.editSearchCriteria)}" v-if="searchType === 'Advanced' && !selectedPerson">
                <div v-if="isLoadingSearchCriteria" class="loading"><div class="loader-bg"></div><span class="loader">Loading...</span></div>
                <div v-if="(!$store.state.editSearchResults || ($store.state.editSearchCriteria))">

                    <b-link class="collapsed" v-b-toggle.displaySearchCriteria rel="noopener">
                        <h5 class="text-white d-inline">Search Criteria
                        </h5>
                    </b-link>
                    <button v-if="$route.name ==='list'" class="btn btn-link text-white" title="Edit Search Criteria" @click.prevent="showEditSearchCriteriaForm()">
                        <i class="fas fa-pen-square fa-2x"></i>
                    </button>

                        <span class="display-criteria ms-3"  v-html="criteriaStr" id="criteriaContainer" :class="{'expanded' : showHideLinkText === 'Less'}"></span>
                        <a v-if="criteriaIsTooLong" href @click.prevent="showAllCriteria()" id="viewMore" :class="{'expanded' : showHideLinkText === 'Less'}">View {{showHideLinkText}} Criteria</a>
                </div>

                <transition name="fade" >
                    <div class="search-form-container mt-3" v-if="showCriteria && ($route.params.search_id && $store.state.editSearchCriteria)">
                        <ReviseSearch refpage="results" ref="tileContent"/>
                    </div>
                </transition>

            </div>

            <div class="smart-search-section mt-2" v-if="searchType === 'Smart'">
                <SmartSearch :showTitle="false" :showHelpText="false" fromPage="searchResults" v-if="!showCriteria && ($route.name ==='list' || $route.name === 'charts' || $route.name === 'map')"/>
                <div class="row" v-else>
                    <div class="col-12">
                        <h5 class="title">Search Text: </h5>
                        <span>{{smartSearchText}}</span>
                    </div>
                </div>
                <transition name="fade" >
                    <div class="search-form-container mt-3" v-if="showCriteria && ($route.params.search_id)">
                        <ReviseSearch refpage="results"/>
                    </div>
                </transition>
            </div>
        </div> <!-- //col-12 -->
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import ReviseSearch from '@/components/home/ReviseSearch.vue';
import SmartSearch from '@/components/searchFields/SmartSearch.vue';
import bus from '@/shared/event-bus.js';
import moment from 'moment';

// import globalMixins from '@/globalMixins';

export default {
    name: 'searchCriteria',
    // mixins: [globalMixins],
    components: {
      ReviseSearch,
      SmartSearch
    },
    computed: {
        ...mapGetters([
            'searchType',
            'isExportingFile',
            'selectedPerson',
            'currentQueryDetails'
        ]),
        criteriaIsTooLong: function () {
            var criteriaTextObj = document.getElementById('criteriaContainer');

            if (this.criteriaStr) {
                if (criteriaTextObj && criteriaTextObj.clientHeight + 5 <   criteriaTextObj.scrollHeight) {
                    return true;
                }
            }

            return false;
        },
        hasData: function () {
            switch (this.$route.name) {
                case 'list':
                    if (this.$store.state.searchResults && this.$store.state.searchResults.length > 0) {
                        return true;
                    }
                    break;
                case 'publications':
                    if (this.$store.state.publicationResults && this.$store.state.publicationResults.results.length > 0) {
                        return true;
                    }
                    break;
                case 'patents':
                    if (this.$store.state.patentResults && this.$store.state.patentResults.results.length > 0) {
                        return true;
                    }
                    break;
                case 'clinicalStudies':
                    if (this.$store.state.clinicalStudyResults && this.$store.state.clinicalStudyResults.results.length > 0) {
                        return true;
                    }
                    break;
            }
            return false;
        },
        smartSearchText: function() {
            return this.$store.state.searchCriteria.smart_search_text || "";
        },
    },
    data: function () {
        return {
            serverless: false,
            data: null,
            showCriteria: false,
            showHideLinkText: 'More',
            searchFieldSpecs: window.searchFieldSpecs,
            criteriaStr: '',
            isLoadingSearchCriteria: false,
            loadingSmartSearch: false,
        };
    },
    watch: {
        '$store.state.searchCriteria': function (n, o) {
            if (n) {
                this.getCriteriaStr();
            }
        }
    },
    mounted () {
        if ((this.searchMeta && !this.searchMeta.search_id) || !this.$route.params.search_id) {
                this.$router.push({ path: '/' });
        } else {
            this.showCriteria = false;

            let $this = this;
            bus.$on('update:showCriteria', function (val) {
                $this.showCriteria = val;
            })
            //from edit link, show the crit form (from store) and then clear it...
            if(this.currentQueryDetails && this.currentQueryDetails.showCriteria)   {
                this.showCriteria = true;
                delete this.currentQueryDetails.showCriteria;
            }

            if (!this.$store.state.searchCriteria || Object.keys(this.$store.state.searchCriteria).length === 0) {
                bus.$emit('get:searchCriteria');
                if (this.searchType !== 'Smart') {
                    this.getLookupData();
                }
            } else {
                this.getCriteriaStr();
            }
        }

        bus.$on('criteria:received', () => {
            this.getCriteriaStr();
        });

        bus.$on('update:searchCriteria', () => {
            this.$nextTick(() => {
                this.getCriteriaStr();
            });
        });
        this.setFullscreen(true);
    },
    methods: {
        ...mapActions([
            'setFullscreen',
            'setEditSearchResultsFlag',
            'setLookup',
            'setSearchMode',
            'setSearchType',
            'setExportCriteria',
            'setCurrentQueryDetailsAction',
            'setSearchCriteria'
        ]),
        getCriteriaStr () {
            var tempCriteria = this.$store.state.searchCriteria,
                htmlStr = '',
                criteriaTextObj,
                dispVal,
                dispName,
                fieldObj,
                criteriaJSON = {},
                FYFound = false;

            if (this.$store.state.editSearchResults) {
                tempCriteria = this.$store.state.editSearchCriteria;
            }

            if (this.searchType === 'Smart' || tempCriteria.smart_search_text) {
                if (typeof tempCriteria.smart_search_text === 'string') {
                    htmlStr += '<span class="criteria"><span class="title">Search Text:</span> <span>' + tempCriteria.smart_search_text + '</span></span>';
                    criteriaJSON['Quick Search Text'] =  tempCriteria.smart_search_text;
                } else {
                    htmlStr += '<span class="criteria"><span class="title">Search Text:</span> <span>' + tempCriteria.smart_search_text.join(', ') + '</span></span>';
                    criteriaJSON['Quick Search Text'] =  tempCriteria.smart_search_text.join(', ');
                }

            } else {
                for (let key in tempCriteria) {
                    dispVal = this.getDisplayValue(key);
                    dispName = this.getDisplayName(key);

                    if (dispVal !== '' && dispVal !== 'undefined' && dispName !== '') {
                        if (key === 'fiscal_years') {
                            FYFound = true;
                        }
                        htmlStr += '<span class="criteria"><span class="title">' + this.getDisplayName(key) + ':</span> <span>' + dispVal + '</span></span>';
                        // replacing zero width space character [\u200b] due to encoding issue in exported csv file
                        criteriaJSON[dispName] = dispVal.replace(/\u200b/ig,'').replace(/\u00a0/ig,' ');
                    }
                }
            }
            if ((htmlStr === '' || !FYFound) && this.searchType !== 'Smart') {
                dispName = this.getDisplayName('fiscal_years');
                criteriaJSON[dispName] = 'Active Projects';
                htmlStr = '<span class="criteria"><span class="title">Fiscal Year:</span> <span>Active Projects</span></span>' + htmlStr;
            }

            this.setExportCriteria(criteriaJSON);
            this.criteriaStr = htmlStr;
        },
        getLookupData () {
            var fieldSpecs = window.searchFieldSpecs,
                url,
                field;

            for (let inputField in fieldSpecs) {
                field = fieldSpecs[inputField];
                if (!this.$store.state.lookup[field.id] && ((field.control === 'MultiSelect' && !field.dynamicLookup) || field.control === 'InputRange')) {
                    url = '/services/Lookup/' + window.snakeToCamel(field.id);

                    this.callLookupService(url, field.id);
                }
            }
        },
        callLookupService (url, thisId) {
            var  xhr = new XMLHttpRequest();

            xhr.open('GET', url, true);
            xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            xhr.onload = () => {
                if (xhr.status === 200) {
                    let data = JSON.parse(xhr.response);

                    if (this.id === '' || thisId === 'award_amount_range') {
                        this.setLookup({
                            field: thisId,
                            data: copyData(data)
                        });
                    } else {
                        if (data.length !== 0 && data[0].display !== undefined && data[0].value !== undefined) {
                            this.setLookup({
                                field: thisId,
                                data: copyData(data)
                            });
                            if (this.searchType !== 'Smart') {
                                this.getCriteriaStr();
                            }
                        }
                    }
                }
            };
            xhr.onerror = () => {
            };
            xhr.send();
        },
        getDisplayName (name) {
            var tempCriteria = this.$store.state.searchCriteria;

            if (this.$store.state.editSearchResults) {
                tempCriteria = this.$store.state.editSearchCriteria;
            }

            name = name.replace('__free_text', '');

            if (name === 'search_text') {
                return 'Text Search';
            } else if (name === 'operator') {
                return '';
            } else if (name === 'search_field') {
                return 'Limit to';
            }

            for (let field in window.searchFieldSpecs) {
                if(window.searchFieldSpecs[field] && (window.searchFieldSpecs[field].id === name || window.searchFieldSpecs[field].idFreeText === name)) {
                    return window.searchFieldSpecs[field].title;
                }
                else if (window.searchFieldSpecs[field].fields) {
                    for (let subField in window.searchFieldSpecs[field].fields) {
                        if(subField === name) {
                            return window.searchFieldSpecs[field].title;
                        }
                    }
                }
                else if (window.searchFieldSpecs[field].additionalControl) {
                    for (let i = 0; i < window.searchFieldSpecs[field].additionalControl.options.length; i++) {
                        if (window.searchFieldSpecs[field].additionalControl.options[i].id === name && tempCriteria[window.searchFieldSpecs[field].id] && tempCriteria[window.searchFieldSpecs[field].id].length > 0) {
                            if (window.searchFieldSpecs[field].additionalControl.label !== '') {
                                return window.searchFieldSpecs[field].additionalControl.label;
                            } else {
                                return window.searchFieldSpecs[field].additionalControl.options[i].label;
                            }
                        }
                    }
                }
            }
            return '';
        },
        getDisplayValue (name) {
            var searchCriteria = this.$store.state.searchCriteria,
                returnVal = '',
                tempEditSearchResults = this.$store.state.editSearchResults,
                apText = 'Active Projects',
                selectedItem,
                sharedSpec = window.searchFieldSpecs,
                // dynamicLookup = false,
                tempCriteria,
                returnValArr = [],
                awardTypeArr = [],
                fieldObj;

            if (tempEditSearchResults) {
                searchCriteria = this.$store.state.editSearchCriteria;
            }

            tempCriteria = searchCriteria[name];

            for (let field in window.searchFieldSpecs) {
                if(window.searchFieldSpecs[field] && window.searchFieldSpecs[field].id === name) {
                    // dynamicLoo/kup = !!window.searchFieldSpecs[field].dynamicLookup;
                    fieldObj = window.searchFieldSpecs[field];
                    break;
                }
            }

            if (name.indexOf('__field_text') === -1 && name.indexOf('__free_text') === -1) {
                if ((name === 'is_agency_admin' || name === 'is_agency_funding') && tempCriteria) {
                    returnVal = 'Yes';
                } else if (name === 'match_all_spending_categories') {
                    if (tempCriteria.toString() === "true") {
                        returnVal = 'AND';
                    } else {
                        returnVal = 'OR';
                    }
                } else if (typeof tempCriteria === 'string') {
                    if (name === 'search_text') {
                        returnVal += unescape(tempCriteria);
                        if (tempCriteria) {
                            returnVal += ' (' + (!searchCriteria['operator'] || searchCriteria['operator'] === '' ? 'Advanced' : searchCriteria['operator']) + ')';
                        }
                    } else {
                        returnVal += tempCriteria;
                    }
                } else if(typeof tempCriteria === 'object') {
                    if (tempCriteria.length && tempCriteria.length > 0) {
                        for (let i = 0; i < tempCriteria.length; i++) {
                            if (!tempEditSearchResults) {
                                let isParentSelected = false;

                                if (typeof tempCriteria[i] === 'string') {
                                    returnValArr.push(tempCriteria[i]);
                                } else {
                                    if (tempCriteria[i].parent_value) {
                                        // returnValArr.push(tempCriteria[i]);
                                        isParentSelected = tempCriteria.some((item) => {
                                            return item.value === tempCriteria[i].parent_value;
                                        });
                                    }
                                    // only add value to parsed criteria if
                                    // its parent value is not selected
                                    if (!isParentSelected) {
                                        let tempStr = tempCriteria[i].abbreviation ? tempCriteria[i].abbreviation : tempCriteria[i].display;
                                        if (tempStr) {
                                            returnValArr.push(tempStr);
                                        }
                                    }
                                }
                            } else {
                                if (this.$store.state.lookup[name] && !fieldObj.dynamicLookup) {
                                    selectedItem = this.$store.state.lookup[name].filter((item) => {
                                        if (item.value.toString() === tempCriteria[i].toString() || ((name === 'award_types' || name === 'funding_mechanism') && item.value.indexOf(tempCriteria[i]) !== -1)) {
                                            return item;
                                        }
                                    });

                                    if (selectedItem && selectedItem.length > 0) {
                                        if (selectedItem[0].children_values && selectedItem[0].children_values.length > 0) {
                                            let tempStr = selectedItem[0].abbreviation ? selectedItem[0].abbreviation : selectedItem[0].display;
                                            returnValArr.push(tempStr);
                                        } else {
                                            if (returnValArr.indexOf(selectedItem[0].display) === -1) {
                                                returnValArr.push(selectedItem[0].display);
                                                if (name === 'award_types') {
                                                    awardTypeArr.push(selectedItem[0]);
                                                }
                                            }
                                        }
                                    } else {
                                        if (tempCriteria[i].display) {
                                            returnValArr.push(tempCriteria[i].display);
                                        } else if (tempCriteria[i].indexOf(';') === -1) {
                                            returnValArr.push(tempCriteria[i]);
                                        }
                                        if (tempCriteria[i] === 'ap') {
                                            returnValArr.push(apText);
                                        }
                                    }
                                } else {
                                    returnValArr.push(tempCriteria[i]);
                                }
                            }
                        }
                        if (name === 'pi_names' || name === 'pi_profile_ids') {
                            returnVal = returnValArr.join('; ');
                        } else if (name === 'search_field') {
                            if (searchCriteria[fieldObj.dependentField]) {
                                for (let i = 0; i < fieldObj.options.length; i++) {
                                    // dbValues for this field is "A". If returnValArr does not have specific field value e.g. Abstract, title or terms then we are comparing it with dbValue
                                    if (returnValArr.indexOf(fieldObj.options[i].value) !== -1 || !returnValArr || returnValArr[0].toLowerCase() == fieldObj.dbValues[0].toLowerCase()) {
                                        returnVal += (returnVal === '' ? '' : ', ') + fieldObj.options[i].label;
                                    }
                                }
                            }
                        } else {
                            returnVal = returnValArr.join(', ');
                            if (name === 'fiscal_years') {
                                returnVal = returnVal.replace('ap', apText);
                            }
                        }
                    } else if (name === 'award_amount_range') {
                        if (tempCriteria && tempCriteria.min_amount !== null && tempCriteria.min_amount !== undefined) {
                            if (tempCriteria.min_amount !== 0) {
                                returnVal += 'From: ' + window.filters.formatLargeCurrency(tempCriteria.min_amount);
                                returnVal += ' To ' + window.filters.formatLargeCurrency(tempCriteria.max_amount);
                            } else {
                                returnVal += ' upto ' + window.filters.formatLargeCurrency(tempCriteria.max_amount);
                            }
                        }
                    } else if (name === 'search_field') {
                        if (searchCriteria[fieldObj.dependentField]) {
                            for (let i = 0; i < fieldObj.options.length; i++) {
                                returnVal += (returnVal === '' ? '' : ', ') + fieldObj.options[i].label;
                            }
                        }
                    } else {
                        
                        if (tempCriteria.from_date && !tempCriteria.to_date) {
                            let fromDateStr = moment(tempCriteria.from_date).format('MM/DD/YYYY');
                            returnVal += 'On or After: ' + fromDateStr;
                        }
                        else if (!tempCriteria.from_date && tempCriteria.to_date) {
                            let toDateStr = moment(tempCriteria.to_date).format('MM/DD/YYYY');
                            returnVal += 'On or Before: ' + toDateStr;
                        } else {
                            if (tempCriteria.from_date) {
                                let fromDateRngStr = moment(tempCriteria.from_date).format('MM/DD/YYYY');

                                returnVal += 'From ' + fromDateRngStr;
                            }
                            if (tempCriteria.to_date) {
                                let toDateRngStr =  moment(tempCriteria.to_date).format('MM/DD/YYYY');
                                returnVal += ' To ' + toDateRngStr;
                            }
                        }
                    }
                }
                else if (typeof tempCriteria === 'boolean') {
                    if (tempCriteria === true) {
                        returnVal += 'Yes';
                    }
                }
            } else {
                if (tempCriteria !== '' && tempCriteria.length !== 0 && searchCriteria[name.replace('__free_text', '')].length == 0) {
                    returnVal = tempCriteria;
                }
            }

            return returnVal;
        },
        showEditSearchCriteriaForm () {
            this.showCriteria = !this.showCriteria;

            var savedSearchObj,
                curSearchId = this.$route.params.search_id;

            if (this.$store.state.savedSearches &&  this.$store.state.savedSearches.length > 0) {
                savedSearchObj = _.find(this.$store.state.savedSearches, function (searchObj) {
                    return searchObj.search_id === curSearchId;
                });
                if (savedSearchObj) {
                    this.setCurrentQueryDetailsAction(savedSearchObj);
                }
            }
        },
        showAllCriteria () {
            this.showHideLinkText = this.showHideLinkText === 'More' ? 'Less' : 'More';
        }
    }

}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';
.criteria-container {
    display: inline-block;
    vertical-align: top;
    position: relative;
    background-color: transparent;
    padding: 5px 10px 0;
    .display-criteria {
        max-height: 60px;
        overflow: hidden;
        // margin-bottom: 10px;
        display: inline-block;
        &.expanded {
            max-height: 100%;
            overflow: auto;
            display: inline;
        }
    }

    a {
        color: $white;
        text-decoration: underline;
        // margin: 0 15px;
        margin: 0;
        &.expanded {
           margin: 0 15px;
        }
    }

    .show-more-less {
        margin-left: 15px;
        &.new-line {
            float: right;
            margin-left: 0px;
        }
        a {
            // display: none;
            position: absolute;
            bottom: 0px;
            left: -120px;
            &.display-link {
                display: inline-block;
            }
        }
    }
}

.search-criteria-section {
    width: calc(100% - 210px);
}

.smart-search-section {
    .title {
        font-weight: bold;
        color: $white;
        display: inline;
    }
}
.criteria-container {
    padding-right: 185px;

    .show-more-less {
        position: absolute;
        right: 10px;
        bottom: 5px;
    }
}

</style>